module.exports = __webpack_public_path__ + "img/jt-honour-3.880c8ef2.png";